import React, { useContext } from 'react';

export interface IIFrameState {
  isIFrame: boolean;
}

const IFrameContext = React.createContext<IIFrameState>({ isIFrame: false });

export const IFrameContextProvider = IFrameContext.Provider;
export const IFrameContextConsumer = IFrameContext.Consumer;
export const useIFrame = () => useContext(IFrameContext);
